const compatModules = {};
import * as Module1 from "./helpers/and";
compatModules["./helpers/and"] = Module1;
import * as Module2 from "./helpers/eq";
compatModules["./helpers/eq"] = Module2;
import * as Module3 from "./helpers/gt";
compatModules["./helpers/gt"] = Module3;
import * as Module4 from "./helpers/gte";
compatModules["./helpers/gte"] = Module4;
import * as Module5 from "./helpers/has";
compatModules["./helpers/has"] = Module5;
import * as Module6 from "./helpers/includes";
compatModules["./helpers/includes"] = Module6;
import * as Module7 from "./helpers/lt";
compatModules["./helpers/lt"] = Module7;
import * as Module8 from "./helpers/lte";
compatModules["./helpers/lte"] = Module8;
import * as Module9 from "./helpers/not-eq";
compatModules["./helpers/not-eq"] = Module9;
import * as Module10 from "./helpers/not";
compatModules["./helpers/not"] = Module10;
import * as Module11 from "./helpers/or";
compatModules["./helpers/or"] = Module11;
import * as Module12 from "./index";
compatModules["./index"] = Module12;
import * as Module13 from "./utils/truth-convert";
compatModules["./utils/truth-convert"] = Module13;
export default compatModules;